import { useChannels } from 'providers/useChannels/useChannels';

type ReplayDepthCheckInput = {
    channel_id?: string;
    start?: number;
    startTime?: number;
};

export const useIsWithinChannelReplayDepth = () => {
    const { getChannelById } = useChannels();

    return (input: ReplayDepthCheckInput): boolean => {
        if (input == null) return false;
        const channel = getChannelById(input.channel_id);
        if (!channel?.replay || !channel.replay_depth) return false;
        const start = input.start ?? input.startTime;
        if (!start) return false;
        const nowSec = Math.floor(Date.now() / 1000);
        return start >= nowSec - channel.replay_depth;
    };
};
